export default __webpack_public_path__ + "static/media/accomm_img_12.8bc89ca9.JPG";